import { Component, OnInit } from '@angular/core';
import { MicroempresarioService } from '../services/microempresario.service';
import { ActivatedRoute, Params } from '@angular/router';
import { UserService } from '../../services/user.service';

@Component({
    selector: 'app-aceptacion-encuesta',
    templateUrl: './aceptacion-encuesta.component.html',
    styleUrls: ['./aceptacion-encuesta.component.scss'],
    standalone: false
})
export class AceptacionEncuestaComponent implements OnInit {
idSolicitud: string = '';
  aliadoFinanciero: string = '';
  user: any;
  constructor(
    private _route: ActivatedRoute,
    private _microempresarioService: MicroempresarioService,
    private _userService: UserService
  ) {
    this.user = this._userService.getUser();
  }

  ngOnInit(): void {
    this.traerNumeroSolicitud();
  }

  traerNumeroSolicitud() {
    this._route.params.subscribe((params: Params) => {
      this.idSolicitud = params['id'];
      //this.traerIF();
    });
  }

  traerIF() {
    this._microempresarioService
      .getIntermediarioAproboSolicitud(this.idSolicitud)
      .subscribe(
        (response) => {
          if (response['exitoso'] == true) {
            var data = response['data'];
            this.aliadoFinanciero = data.nombreIntermediarioAproboSolicitud;
          }
        },
        (error) => {}
      );
  }
}
